
import { FormProvider as HookFormProvider } from "react-hook-form"

/**
 * Wrapper for react-hook-form's FormProvider
 */
const FormProvider = HookFormProvider

export { FormProvider }
